<div class="mat-typography mat-body mat-app-background">
  <div class="dialog-close">
    <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal()">close</span>
  </div>
  <article class="content-section">
    <!-- Header -->
    <h2>
      <slot name="leave-gate-header">You Are Leaving Our Website</slot>
    </h2>

    <!-- Description -->
    <section class="description">
      <p>
        <slot name="leave-gate-desc">Do you wish to continue?</slot>
      </p>
    </section>

    <section class="buttons">
      <button mat-raised-button color="primary" type="button" (click)="confirmDepartureTime()"><span>
          <slot name="leave-gate-confirm">Yes</slot>
        </span></button>
      <button mat-raised-button color="primary" type="button" (click)="closeModal()"><span>
          <slot name="leave-gate-abort">No</slot>
        </span></button>
    </section>
  </article>
</div>
